<template>
  <div id="ticket_r" >
    <top></top>
    <div class="main">
      <div class="content">
        <div class="go-back" @click="goBack">返回</div>
        <div class="ticket_r_title">
          <p>申票</p>
          <div class="ticket_r_signup">
            已通过人数：<span>{{ reviewedPeople ? reviewedPeople : 0 }}</span>
            总人数：<span>{{ total }}</span>
          </div>
        </div>
        <div class="ticket_r_border"></div>
        <div class="ticket_r_search">
          <div>
            <p>名字</p>
            <el-input placeholder="请输入" v-model="real_name"></el-input>
          </div>
          <div>
            <p>电话</p>
            <el-input placeholder="请输入" v-model="mobile"></el-input>
          </div>
          <div>
            <p>公司</p>
            <el-input placeholder="请输入" v-model="company_name"></el-input>
          </div>
          <div>
            <p>报名方式</p>
            <el-select v-model="enroll_channel" placeholder="请选择">
              <el-option
                  v-for="item in enroll_channel_options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <div>
            <p>行业</p>
            <el-select v-model="industry" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->
          <div>
            <p>审核状态</p>
            <el-select v-model="audit_status" placeholder="请选择">
              <el-option
                  v-for="item in ticket_status_options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="ticket_r_search_button" @click="getLists">搜索</div>
          <div class="ticket_r_search_button" @click="resetSearchCriteria">
            重置
          </div>
        </div>
        <div class="ticket_r_border second"></div>
        <div class="ticket_r_button">
          <div class="declare_fillButton" @click="handleBatchApprove">
            批量通过
          </div>
        </div>
        <div class="ticket_r_table">
          <el-table
              v-loading="loading"
              :data="ticket_table_data"
              stripe
              style="width: 100%"
              @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="venue_name" label="活动名称" min-width="240">
            </el-table-column>
            <el-table-column
                prop="audit_status_text"
                label="状态"
                min-width="100"
            ></el-table-column>
            <el-table-column
                prop="enroll_channel_text"
                label="报名方式"
                min-width="100"
            ></el-table-column>
            <el-table-column
                prop="real_name"
                label="姓名"
                min-width="120"
            ></el-table-column>
            <el-table-column
                prop="seat"
                label="座位号"
                min-width="120"
            ></el-table-column>
            <el-table-column
                prop="company_name"
                label="公司"
                min-width="200"
            ></el-table-column>
            <el-table-column
                prop="mobile"
                label="手机号"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="create_time"
                label="报名时间"
                min-width="150"
            ></el-table-column>
            <el-table-column label="操作" min-width="130">
              <template slot-scope="scope">
                <span
                    class="ticket_r_table_actions"
                    @click="handleShowTicketDetail(scope.row.id)"
                >查看</span
                >
                <span
                    v-if="scope.row.audit_status == 0"
                    class="ticket_r_table_actions"
                    @click="
                    handleShowTicketReview(scope.row.audit_status, scope.row.id)
                  "
                >审核</span
                >
                <span
                    @click="handleDeleteRegistrationPerson(scope.row.id)"
                    class="ticket_r_table_actions"
                    style="color: #ff2828"
                >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="ticket_r_pagination">
          <el-pagination
              :current-page="currentPage"
              :page-size="pageSize"
              @current-change="changeCurrentPage"
              background
              layout="prev, pager, next"
              :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
        :visible.sync="showTicketDetail"
        class="ticketDetail"
        width="40%"
        @close="handleCloseTicketDetail"
    >
      <p class="ticket_detail_title">
        查看详情 <span>*只可修改状态、座位号、VIP</span>
      </p>
      <el-form
          :model="detailForm"
          :rules="detailRules"
          ref="detailFormRef"
          label-position="top"
      >
        <div class="flex">
          <el-form-item label="活动名称" prop="venue_name">
            <el-input disabled v-model="detailForm.venue_name"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="real_name">
            <el-input disabled v-model="detailForm.real_name"></el-input>
          </el-form-item>
          <el-form-item label="公司地址" prop="company_address">
            <el-input disabled v-model="detailForm.company_address"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="mobile">
            <el-input disabled v-model="detailForm.mobile"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select disabled v-model="detailForm.sex" placeholder="请选择">
              <el-option
                  v-for="item in sex_options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号" prop="certificate_number">
            <el-input
                disabled
                v-model="detailForm.certificate_number"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="company_name">
            <el-input disabled v-model="detailForm.company_name"></el-input>
          </el-form-item>
          <!-- <el-form-item label="行业" prop="company_name">
            <el-input v-model="detailForm.industry"></el-input>
          </el-form-item> -->
          <el-form-item label="公司职务" prop="position">
            <el-input disabled v-model="detailForm.position"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="提交时间" prop="create_time">
          <el-input disabled v-model="detailForm.create_time"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="audit_status">
          <el-select
              disabled
              v-model="detailForm.audit_status"
              placeholder="请选择"
          >
            <el-option
                v-for="item in ticket_status_options"
                :key="item.value"
                :label="item.name"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="flex">
          <el-form-item label="座位号" prop="seat">
            <el-input v-model="detailForm.seat"></el-input>
          </el-form-item>
          <el-form-item label="VIP" prop="ticket_type">
            <el-radio
                v-for="(item, index) in ticket_type_options"
                :key="index"
                v-model="detailForm.ticket_type"
                :label="item.value"
            >{{ item.name }}
            </el-radio
            >
          </el-form-item>
        </div>
      </el-form>
      <div class="title_detail_button">
        <div class="declare_borderButton" @click="handleCloseTicketDetail">
          取消
        </div>
        <div class="declare_fillButton" @click="verifyForm">保存</div>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="showTicketReview"
        @close="handleCloseTicketReview"
        title="审核"
        width="30%"
    >
      <div class="ticket_r_review">
        <p>审核结果:</p>
        <el-select v-model="reviewResult" placeholder="请选择">
          <el-option
              v-for="item in ticket_status_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="ticket_r_review" v-if="reviewResult == 2">
        <p>驳回原因:</p>
        <el-input
            v-model="reject_reason"
            placeholder="请输入驳回原因"
        ></el-input>
      </div>
      <div class="declare_fillButton" @click="handleReviewResult">确定</div>
    </el-dialog>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import {
  getDictionary,
  getRegistrationPersonnel,
  deleteRegistrationPersonnel,
  getRegistrationPersonnelDetail,
  editRegistrationPersonnelDetail,
  examineRegistrationPersonnel,
  batchApproveRegistrationPersonnel,
} from "../../api/api";

export default {
  name: "invitationList",
  components: {top},
  created() {
    this.activityId = this.$route.query.id;
    if (!this.activityId) {
      this.$message.error("未获取到活动ID,请联系管理员");
      return false;
    }
    this.getDict();
  },
  data() {
    return {
      activityId: "",
      currentPersonnalId: "",
      loading: false,
      showTicketDetail: false,
      showTicketReview: false,
      real_name: "",
      mobile: "",
      company_name: "",
      enroll_channel: "",
      industry: "",
      audit_status: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      ticket_table_data: [],
      selectedRows: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      reviewResult: "",
      detailForm: {},
      detailRules: {
        audit_status: [
          {
            required: true,
            message: "请选择活动状态",
            trigger: "blur",
          },
        ],
        // seat: [
        //   {
        //     required: true,
        //     message: "请输入座位号",
        //     trigger: "blur",
        //   },
        // ],
        ticket_type: [
          {
            required: true,
            message: "请选择是否是vip",
            trigger: "blur",
          },
        ],
      },
      enroll_channel_options: [],
      ticket_status_options: [],
      ticket_type_options: [],
      sex_options: [],
      reject_reason: "",
      reviewedPeople: "",
    };
  },
  methods: {
    async getDict() {
      let dictionaryString =
          "?type=enroll_channel,ticket_audit_status,ticket_type,sex";
      const res = await getDictionary(dictionaryString);
      if (res.code == 1) {
        this.enroll_channel_options = res.data.enroll_channel;
        this.ticket_status_options = res.data.ticket_audit_status;
        this.ticket_type_options = res.data.ticket_type;
        this.sex_options = res.data.sex;
        this.getList();
      } else {
        this.loading = false;
        this.$message.warning("获取数据字典失败！");
      }
    },
    getLists() {
      this.currentPage = 1
      this.getList()
    },
    async getList() {
      this.loading = true;
      let obj = {
        activities_id: this.activityId,
        page_no: this.currentPage,
        page_size: this.pageSize,
        real_name: this.real_name,
        mobile: this.mobile,
        company_name: this.company_name,
        enroll_channel: this.enroll_channel,
        audit_status: this.audit_status,
      };
      const res = await getRegistrationPersonnel(this.$qs.stringify(obj));
      this.loading = false;
      if (res.code == 1) {
        res.data.lists.forEach((item) => {
          this.enroll_channel_options.forEach((item2) => {
            if (item.enroll_channel == item2.value) {
              item.enroll_channel_text = item2.name;
            }
          });
          this.ticket_status_options.forEach((item3) => {
            if (item.audit_status == item3.value) {
              item.audit_status_text = item3.name;
            }
          });
        });
        this.ticket_table_data = res.data.lists;
        this.total = res.data.count;
        this.reviewedPeople = res.audited_count;
      } else {
        this.$message.error(res.msg);
      }
    },
    verifyForm() {
      this.$refs["detailFormRef"].validate((valid, field) => {
        if (valid) {
          this.handleEditTicketDetail();
        } else {
          let arr = Object.keys(field);
          let tips = field[arr[0]][0].message;
          this.$message.error(tips);
          return false;
        }
      });
    },
    handleDeleteRegistrationPerson(id) {
      this.$confirm("确定要删除该报名人员信息？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            const res = await deleteRegistrationPersonnel({
              id,
              activities_id: this.activityId,
            });
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {
          });
    },
    async handleShowTicketDetail(id) {
      let obj = {
        id,
        activities_id: this.activityId,
      };
      const res = await getRegistrationPersonnelDetail(this.$qs.stringify(obj));
      if (res.code == 1) {
        if (Array.isArray(res.data) && res.data.length == 0) {
          this.$message.error("该报名人员信息出错了，请联系管理员！");
          return false;
        }
        this.showTicketDetail = true;
        res.data.sex = String(res.data.sex);
        res.data.ticket_type = String(res.data.ticket_type);
        res.data.audit_status = String(res.data.audit_status);
        this.detailForm = res.data;
        this.currentPersonnalId = id;
      } else {
        this.$message.error(res.msg);
      }
    },
    async handleEditTicketDetail() {
      let obj = this.detailForm;
      obj.activities_id = this.activityId;
      obj.id = this.currentPersonnalId;
      const res = await editRegistrationPersonnelDetail(obj);
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.detailForm = {};
        this.currentPersonnalId = "";
        this.showTicketDetail = false;
        this.getList();
      } else {
        this.$message.error(res.msg);
      }
    },
    handleShowTicketReview(status, id) {
      this.reviewResult = String(status);
      this.currentPersonnalId = id;
      this.showTicketReview = true;
    },
    handleReviewResult() {
      this.$confirm("是否确认审核结果?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            if (this.reviewResult == 0) {
              this.$message.warning("审核结果不能为待审核！");
              return false;
            }
            if (this.reviewResult == 2 && this.reject_reason === "") {
              this.$message.warning("当审核结果为驳回时，必须需要有驳回原因！");
              return false;
            }
            let data = {
              id: this.currentPersonnalId,
              activities_id: this.activityId,
              audit_status: this.reviewResult,
              reject_reason: this.reject_reason,
            };
            const res = await examineRegistrationPersonnel(data);
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.reviewResult = "";
              this.currentPersonnalId = "";
              this.showTicketReview = false;
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {
          });
    },
    handleBatchApprove() {
      this.$confirm("确定要批量通过这些报名人员吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            let arr = this.selectedRows;
            if (arr.length === 0) {
              this.$message.warning("请选择报名人员！");
              return false;
            }
            let ids = "";
            arr.forEach((item) => {
              ids += item.id + ",";
            });
            ids = ids.slice(0, -1);
            const res = await batchApproveRegistrationPersonnel({
              ids,
              activities_id: this.activityId,
            });
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {
          });
    },
    handleCloseTicketDetail() {
      this.detailForm = {};
      this.currentPersonnalId = "";
      this.showTicketDetail = false;
    },
    handleCloseTicketReview() {
      this.reviewResult = "";
      this.currentPersonnalId = "";
      this.showTicketReview = false;
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    resetSearchCriteria() {
      this.real_name = "";
      this.mobile = "";
      this.company_name = "";
      this.enroll_channel = "";
      this.audit_status = "";
      this.currentPage = 1;
      this.getList();
    },
    changeCurrentPage(val) {
      debugger
      this.currentPage = val;
      this.getList();
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket_r_title {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  p {
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }

  .ticket_r_signup {
    box-sizing: border-box;
    padding-right: 200px;
    font-size: 14px;
    font-weight: 500;
    color: #333;

    span {
      font-size: 22px;
      margin-right: 20px;
      color: #e40080;
    }

    span:last-child {
      margin-right: 0;
    }
  }
}

.ticket_r_border {
  width: 100%;
  height: 5px;
  background-color: #f3f3f3;
  margin: 20px 0;
}

.ticket_r_search {
  display: flex;
  flex-wrap: wrap;

  > div {
    width: 24%;
    margin-right: 2%;
    margin-bottom: 20px;

    p {
      font-size: 14px;
      line-height: 22px;
      font-size: 14px;
      color: #7f8fa4;
      margin-bottom: 8px;
    }

    /deep/ .el-input {
      height: 36px;

      .el-input__inner {
        height: 100%;
        border-radius: 8px;
      }
    }
  }

  .ticket_r_search_button {
    width: 102px;
    height: 36px;
    background-color: #e40080;
    color: #fff;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    border-radius: 8px;
    margin-top: auto;
    cursor: pointer;
    margin-right: 20px;
  }

  .ticket_r_search_button:hover {
    opacity: 0.8;
  }
}

.ticket_r_button {
  display: flex;
  margin-bottom: 30px;

  div {
    width: 104px;
    height: 36px;
    line-height: 36px;
    margin-right: 20px;
  }
}

.ticket_r_table {
  .ticket_r_table_download {
    width: 56px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
  }

  .ticket_r_table_download.disabled {
    background-color: #adb4c7;
    cursor: no-drop;
  }

  .ticket_r_table_actions {
    font-size: 14px;
    color: #409eef;
    cursor: pointer;
    margin-right: 10px;
    font-weight: 500;
  }
}

.ticket_r_pagination {
  margin-top: 60px;

  /deep/ .el-pagination {
    box-sizing: border-box;
    padding-right: 60px;
    text-align: right;
  }
}

/deep/ .el-dialog {
  border-radius: 6px;
  box-sizing: border-box;

  .ticket_r_review {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;

    .el-select {
      margin-left: 20px;
      width: 280px;
    }

    > .el-input {
      margin-left: 20px;
      width: 280px;
    }
  }

  .declare_fillButton {
    margin: 80px auto 0;
  }

  .ticket_detail_title {
    font-weight: 500;
    color: #000;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;

    span {
      color: #e40080;
      font-size: 12px;
      font-weight: 500;
    }
  }
}

.ticketDetail {
  /deep/ .el-dialog {
    .el-dialog__header {
      padding: 0;
    }
  }

  .el-form {
    margin-top: 20px;

    .flex {
      width: 100%;
      align-items: center;
      flex-wrap: wrap;
    }

    /deep/ .el-form-item {
      width: 40%;
      margin-right: 3%;
      margin-bottom: 12px;

      .el-form-item__label {
        line-height: 36px;
      }
    }
  }

  .title_detail_button {
    display: flex;
    width: 272px;
    justify-content: space-between;
    align-items: center;
    margin: 80px auto 0;

    > div:first-child {
      margin-right: 20px;
    }

    .declare_fillButton {
      margin: 0;
    }
  }
}
</style>
